import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDAlert, FDBodyText, FDHeadlineText } from '@facet-wealth/design';
import { Text } from 'Packages/FacetDesign/Components/Text';
import {
  FrequentlyAskedQuestionsNoSpacing,
} from 'Components/UI/FrequentlyAskedQuestions/FrequentlyAskedQuestionsNoSpacing';
import { Articles } from './Articles';

export const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => Text,
    _customProps: { Component: FDHeadlineText, size: 'md', color: 'textSecondary' },
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => Text,
    _customProps: { Component: FDBodyText },
  }, overrideReadOnly)
  .nameOverride('insight', {
    _component: () => FDAlert,
    _customProps: { status: 'info' },
  }, overrideReadOnly)
  .nameOverride('frequentlyAskedQuestions', {
    _component: () => FrequentlyAskedQuestionsNoSpacing,
  }, overrideReadOnly)
  .nameOverride('articles', {
    _component: () => Articles,
  }, overrideReadOnly);
